import { connect } from 'react-redux';

import { getAbbreviationsQueueStats, updateAbbreviation } from './actionSagas'; // You'll need to create these actions
import AudioGenerationQueue from './AudioGenerationQueue'; // Reusing the same component
import { getAbbreviationsQueueData } from './selectors'; // You'll need to create this selector

const mapStateToProps = (state) => ({
  audioGenerationQueueData: getAbbreviationsQueueData(state), // Keep same prop name for component compatibility
});

const mapDispatchToProps = (dispatch) => ({
  getQueueData: () => dispatch(getAbbreviationsQueueStats()),
  updateAudioGeneration: (action) => dispatch(updateAbbreviation(action)), // Keep same prop name
});

const AbbreviationsQueueContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AudioGenerationQueue);

export default AbbreviationsQueueContainer;
